<ion-content class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-title>CurbNTurf Admin</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      @if (error) {
        <ion-note class="error">{{ error }}</ion-note>
      }

      @if (step === 'signIn') {
        <form (ngSubmit)="signIn()">
          <ion-item>
            <ion-input label="Email" labelPlacement="stacked" type="email" name="email" autocomplete="username" [(ngModel)]="email" required></ion-input>
          </ion-item>
          <ion-item>
            <ion-input label="Password" labelPlacement="stacked" type="password" name="password" autocomplete="current-password" [(ngModel)]="password" required></ion-input>
          </ion-item>
          <ion-button expand="block" type="submit" [disabled]="busy">
            @if (busy) { <ion-spinner name="dots"></ion-spinner> } @else { Sign in }
          </ion-button>
        </form>
        <div class="or">or</div>
        @for (provider of providers; track provider) {
          <ion-button class="social" expand="block" fill="outline" color="dark" [disabled]="busy" (click)="socialSignIn(provider)">
            <ion-icon slot="start" [name]="providerIcons[provider]"></ion-icon>
            Continue with {{ provider }}
          </ion-button>
        }
      } @else {
        <p>Your account has a temporary password. Choose a new one to continue.</p>
        <form (ngSubmit)="setNewPassword()">
          <ion-item>
            <ion-input label="New password" labelPlacement="stacked" type="password" name="newPassword" autocomplete="new-password" [(ngModel)]="newPassword" required></ion-input>
          </ion-item>
          <ion-button expand="block" type="submit" [disabled]="busy">
            @if (busy) { <ion-spinner name="dots"></ion-spinner> } @else { Set password }
          </ion-button>
        </form>
      }
    </ion-card-content>
  </ion-card>
</ion-content>
